module.exports = __webpack_public_path__ + "static/media/20190826_154142.image.07052433.png";